<template>
  <div class="">
    <Modal
      v-model="platformListModal"
      width="600"
      :title="platformUpRecTitle"
      :mask-closable="false"
      :loading="loading"
      @on-ok="followUpRecList()"
    >
      <Form
        ref="platformForm"
        :model="platformForm"
        :label-width="120"
        label-position="left"
      >
        <FormItem label="企业开放平台">
          <RadioGroup v-model="platformForm.radio">
            <Radio label="1">开通</Radio>
            <Radio label="0">关闭</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="管理员姓名" v-show="platformForm.radio === '1'">
          <Input placeholder="请输入管理员姓名" v-model="platformForm.name" />
        </FormItem>
        <FormItem label="手机号码"  v-show="platformForm.radio === '1'">
          <Input placeholder="请输入手机号码" v-model="platformForm.number" />
        </FormItem>
				<FormItem label="初始密码" v-show="platformForm.radio === '1'">
          <Input type="password" password placeholder="请输入初始密码" v-model="platformForm.password" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import SmyDatePicker from '@/components/SmyDatePicker'

export default {
  components: {
    SmyDatePicker
  },
  props: {
    agentId: {
      type: Number
    },
    platformUpRecTitle: {
      type: String
    },
    platformUpRecModal: {
      type: Boolean,
      required: true
    },
    platformUpRecRow: {
      type: Object
    }
  },
  data() {
    return {
      loading: true,
      multiple: true,
      num: 6,
      override: true,
      platformListModal: this.platformUpRecModal,
      platformForm: {
        epId: '',
        password: '',
        name: '',
        number: '',
        radio: ''
      }
    }
  },
  methods: {
    // 保存编辑数据
    followUpRecList() {
      let data = {}
      let url = ''
			if (this.platformForm.radio === '') {
				return this.$Message.error('请选择开通或者关闭')
			}
			if (this.platformForm.radio === '1') {
				if (this.platformForm.name === '') {
					return this.$Message.error('请填写管理员姓名')
				}
				if (this.platformForm.password === '') {
					return this.$Message.error('请填写初始密码')
				}
				if (this.platformForm.number === '') {
					return this.$Message.error('请填写电话号码')
				}
				url = '/enterprise/mgr/openplatform/open'
				data = {
					id: this.platformForm.epId,
					name: this.platformForm.name,
					phone: this.platformForm.number,
					password: this.platformForm.password
				}
			} else {
			// 关闭数据空 0
				url = '/enterprise/mgr/openplatform/close'
				data = {
					id: this.platformForm.epId,
					name: '',
					phone: '',
					password: ''
				}
			}
      this.$http.post(url, data).then(res => {
        if (res.success) {
          let msg = '保存成功'
          this.$Message.success(msg)
          this.platformListModal = false
          this.$emit('callback')
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    reload() {
      // 获取状态
	  	this.$http
        .get('/enterprise/mgr/openplatform/state', {
          params: {
            id: this.platformUpRecRow.id ? this.platformUpRecRow.id : this.platformUpRecRow.fk_t_enterprise_id
          }
        }).then(res => {
					if (res.success) {
						this.platformForm.radio = (res.data.is_enable_open_platform).toString()
						this.platformForm.password = res.data.login_name || ''
						this.platformForm.name = res.data.name || ''
						this.platformForm.number = res.data.phone || ''
					} else {
						this.platformForm.radio = ''
						this.platformForm.password = ''
						this.platformForm.name = ''
						this.platformForm.number = ''
					}
				})
      this.platformForm.epId = this.platformUpRecRow.id ? this.platformUpRecRow.id : this.platformUpRecRow.fk_t_enterprise_id
    }
  },
  watch: {
    platformUpRecModal(val) {
      this.platformListModal = val
      if (val) {
        this.reload()
      }
    },
    platformListModal(val) {
      if (!val) {
        this.$emit('backeditModal')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/Opentheplatforms.vue